import { Button, Image, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Radio, RadioGroup, Stack } from '@chakra-ui/react'
import React from 'react';
import Basic from '../../../../assets/thumbs/basic.png';
import Detailed from '../../../../assets/thumbs/detailed.png';
import Stylish from '../../../../assets/thumbs/stylish.png';

export default function PdfExportModal({isOpen, onClose, handleDownload, isDownloading, selectedTemplate, setSelectedTemplate}) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
            <ModalOverlay />
            <ModalContent>
            <ModalHeader>PDF出力</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <RadioGroup onChange={setSelectedTemplate} value={selectedTemplate}>
                <Stack spacing={4}>
                    <Radio value="basic">
                    <Stack direction="row" align="center" spacing={4}>
                        <Image src={Basic} alt="Basic Template" boxSize="100px" />
                        <span>基本テンプレート</span>
                    </Stack>
                    </Radio>
                    <Radio value="detailed">
                    <Stack direction="row" align="center" spacing={4}>
                        <Image src={Detailed} alt="Detailed Template" boxSize="100px" />
                        <span>詳細テンプレート</span>
                    </Stack>
                    </Radio>
                    <Radio value="stylish">
                    <Stack direction="row" align="center" spacing={4}>
                        <Image src={Stylish} alt="Detailed Template" boxSize="100px" />
                        <span>スタイリッシュ</span>
                    </Stack>
                    </Radio>
                </Stack>
                </RadioGroup>
            </ModalBody>
            <ModalFooter>
                <Button onClick={onClose} variant="ghost" mr={3}>
                    キャンセル
                </Button>
                <Button
                    colorScheme="orange"
                    onClick={handleDownload}
                    isLoading={isDownloading}
                >
                    ダウンロード
                </Button>
            </ModalFooter>
            </ModalContent>
        </Modal>
    )
}
